import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { LoginService } from 'app/login/login.service';
import { NativeIntegrationService } from '@mem-shared/native-integration.service';
import { UtilService } from '@mem-shared/util.service';
import { UserSession } from '@mem-shared/user-session';

@Injectable()
export class TouchFaceIdService {
  callNativeForTouchId : number = 0;
  constructor(
    private nativeSvc: NativeIntegrationService,
    private utilSvc: UtilService,
   private loginService: LoginService,
    public userSession: UserSession
  ) {
    this.callNativeForTouchId = 0;
  }

  checkTouchIDCompatibility(nativeOS: 'iOS' | 'Android' | 'web'){
    if(nativeOS === "iOS"|| nativeOS === "Android"){ //Android-Touch
     
      if(this.loginService.callNativeForTouchId == 0 && (this.userSession.getLocalStorageItem('UserCancelTouch') === "false" || this.userSession.getLocalStorageItem('UserCancelTouch') == null)){
        this.loginService.callNativeForTouchId = 1;
        if(this.nativeSvc.isPreLoginTouch != null && this.nativeSvc.isPreLoginTouch === "true") {
          this.nativeSvc.getUsrPwd = true;
        }else{
          
          this.nativeSvc.invokeNativeService(this.utilSvc.getNativeOS(),"touchIdCompatibilityCheck",'');
              //New User Login followed by Registered User Login - Prepopulation issue fix - 4/27
              this.nativeSvc.invokeNativeService(this.utilSvc.getNativeOS(),"prePopulateRegisteredUser",'');
              this.nativeSvc.invokeNativeService(this.utilSvc.getNativeOS(),"isTouchIdEnabled",'');
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/touchFaceId.service.ts